import React from 'react';
import { Switch, Route } from 'react-router-dom';
import List from './users/List';
import Show from './users/Show';
import Editor from './users/Editor';

const AdminUser = () => (
  <Switch>
    <Route component={List} exact path="/admin/users" />
    <Route
      exact
      path="/admin/users/new"
      render={(props) => <Editor key={props.location.pathname} isNew={true} />}
    />
    <Route component={Show} exact path="/admin/users/:id" />
    <Route
      exact
      path="/admin/users/:id/edit"
      render={(props) => <Editor key={props.location.pathname} {...props} />}
    />
  </Switch>
);

export default AdminUser;
